<script setup lang="ts">
type ButtonType = 'Normal' | 'Danger' | 'Plain';
const { text, size = 'md', width = 'fit', buttonType = 'Normal' } = defineProps<{
    text: string;
    size?: 'plain' | 'sm' | 'md';
    width?: 'full' | 'fit';
    buttonType?: ButtonType;
}>();

defineEmits(['click'])




const buttonClasses = [
    size === 'plain' ? '' : 'rounded-md',
    buttonType === 'Danger' ? 'bg-red-600' : buttonType === 'Plain' ? 'bg-slate-100' : 'bg-slate-600',
    width === 'full' ? 'w-full' : 'w-fit',
    size === 'sm' ? 'py-1 px-2' : size === 'md' ? 'py-2 px-4' : size === 'plain' ? 'p-1' : 'py-3 px-6',
    'border border-transparent',
    buttonType === 'Plain' ? 'text-slate-800 text-center' : 'text-center text-sm text-white',
    'transition-all',
    'shadow-md',
    'hover:shadow-lg hover:bg-slate-700',
    'focus:bg-slate-700 focus:shadow-none',
    'active:bg-slate-700 active:shadow-none',
    'disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none',
]
</script>
<template>
    <button @click="$emit('click')" :class="buttonClasses">
        {{ text }}
    </button>
</template>
